import { z } from 'zod';
import { ReviewProvider } from '$constants/review-providers';
import type { SchemaType } from '$util/schema';
import {
  CmsImageSchema,
  CmsLinkSchema,
  CmsNumberSchema,
  CmsRichTextSchema,
  CmsShortTextSchema,
} from '$cms/types';
import { makeContentComponentDefaultConfig } from '$util/makeContentComponentDefaultConfig';

export const defaultConfiguration = makeContentComponentDefaultConfig({
  reviewsProvider: ReviewProvider.TRUSTPILOT,
  sku: undefined,
  backgroundColor: '#fff',
});

export const VrmLookupSchema = {
  translatedEntities: z.object({
    heading: CmsShortTextSchema,
    subheading: CmsRichTextSchema.optional(),
    postcodeLabel: CmsShortTextSchema,
    vrmLabel: CmsShortTextSchema,
    mainCta: CmsShortTextSchema,
    callUsText: CmsShortTextSchema,
    callUsNumber: CmsLinkSchema,
    invalidPostcodeMessage: CmsShortTextSchema.optional(),
    invalidVRMMessage: CmsShortTextSchema.optional(),
    missingPostcodeMessage: CmsShortTextSchema.optional(),
    missingVRMMessage: CmsShortTextSchema.optional(),
    insuredText: CmsShortTextSchema.optional(),
    insuredLogo: CmsImageSchema.optional(),
    backgroundImage: CmsImageSchema.optional(),
    googleReviewsStars: CmsNumberSchema.optional(),
    googleReviewsTotalReviews: CmsNumberSchema.optional(),
    googleReviewsLink: CmsShortTextSchema.optional(),
    googleReviewsReviewsText: CmsShortTextSchema.optional(),
    googleReviewsBasedOnText: CmsShortTextSchema.optional(),
    googleReviewsLogo: CmsImageSchema.optional(),
  }),
  configuration: z
    .object({
      backgroundColor: z.string().optional(),
      reviewsProvider: z.nativeEnum(ReviewProvider).optional(),
      sku: z.string().optional(),
      lazyLoadImages: z.boolean().optional(),
      preloadImages: z.boolean().optional(),
    })
    .default(defaultConfiguration),
};

export type VrmLookupTranslatedEntities = SchemaType<(typeof VrmLookupSchema)['translatedEntities']>;
export type VrmLookupConfiguration = SchemaType<(typeof VrmLookupSchema)['configuration']>;
